var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.type)?_c('v-col',[_c('v-chip',{staticClass:"py-5",attrs:{"color":_vm.color,"outlined":""}},[_vm._v(" "+_vm._s(_vm.description)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }